export async function awaitServerMutation(result: {
  server: Promise<
    | { readonly type: 'success' }
    | { readonly type: 'error'; readonly error: { readonly message: string } }
  >
}): Promise<void> {
  const outcome = await result.server
  if (outcome.type === 'error') {
    throw new Error(outcome.error.message)
  }
}
